import React, { useContext, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import styled from 'styled-components'
import MediaList from 'components/partials/MediaList'
import MediaImage from 'components/partials/MediaImage'
import MediaContent from 'components/partials/MediaContent'
import IconArrowRight from 'components/partials/IconArrowRight'
import Description from 'components/partials/Description'
import Breadcrumb from 'components/Breadcrumb'
import { Link } from 'components/Link'
import ViewModeContext from 'contexts/ViewModeContext'
import useClickLogger from 'api/ClickLogger'

function EventTemplate({ ...doc }) {
  const { t } = useTranslation()
  const viewModeContext = useContext(ViewModeContext)

  doc.__eventsList__ = (
    doc.is_event_series === 'true' && doc.is_range === 'false'
      ? doc.field_event_date.map(event => {
        const { start_time_value: start, end_time_value: end, is_all_day_event: isAllDay, is_range: isRange } = event
        return {
          type: [].concat(doc.event_type).join(', '), // categories
          when: getDateString(start, end),
          hours: getTimeString(start, end, isAllDay || isRange),
        }
      })
      : [doc].map(event => {
        const { event_type: type, event_start_time: start, event_end_time: end, is_all_day_event: isAllDay, is_range: isRange } = event
        return {
          type: [].concat(type).join(', '), // categories
          when: getDateString(start, end),
          hours: getTimeString(start, end, isAllDay || isRange),
        }
      })
  )

  function getTimeString(start, end, isAllDay) {
    return isAllDay === 'true'
      ? t('All day')
      : `${dayjs(start).format('HH:mm')} - ${dayjs(end).format('HH:mm')}`
  }

  function getDateString(start, end) {
    if (viewModeContext.isTable) {
      return dayjs(start).format('L') // 'sv' ? 'YYYY-MM-DD' : 'DD-MM-YYYY'
    } 
      if (dayjs(start).isSame(end, 'day'))
        return dayjs(start).format('dddd D MMMM YYYY')
      if (dayjs(start).isSame(end, 'month'))
        return `${dayjs(start).format('D')} - ${dayjs(end).format('D MMMM YYYY')}`
      if (dayjs(start).isSame(end, 'year'))
        return `${dayjs(start).format('D MMMM')} - ${dayjs(end).format('D MMMM YYYY')}`
      return `${dayjs(start).format('D MMMM YYYY')} - ${dayjs(end).format('D MMMM YYYY')}`
    
  }

  return (
    <ViewModeContext.Consumer>
      {context => context.isTable ? (
        <EventTable {...doc} />
      ) : (
        <EventTeaser {...doc} />
      )}
    </ViewModeContext.Consumer>
  )
}

export default EventTemplate

function EventTable({
  image_url,
  title,
  url,
  _click,
  is_range,
  __eventsList__ = [],
  __eventsList__: [firstEvent] = {},
}) {
  const { trackResultClick } = useClickLogger(_click, url);
  return (
    <tr onClick={trackResultClick} style={{ cursor: 'pointer' }}>
      <td>
        <div className='media'>
          {image_url && <MediaImage src={image_url} />}
          <MediaContent>
            <Link href={url}>
              <span dangerouslySetInnerHTML={{ __html: title }} />
              <IconArrowRight />
            </Link>
          </MediaContent>
        </div>
      </td>
      <td>
        <Description
          modifierClasses='u-text-lowercase u-text-first-uppercase'
          text={firstEvent.when.concat(is_range === 'true' || __eventsList__.length > 1 ? '+' : '')}
        />
      </td>
      <td>
        <Description text={firstEvent.hours} />
      </td>
      <td>
        <Description text={firstEvent.type} />
      </td>
    </tr>
  )
}

const TableRow = styled.div`
  display: table-row;
`
const TableCell = styled.div`
  display: table-cell;
  padding-right: 16px;
`

function EventTeaser({
  title,
  url,
  _click,
  __eventsList__,
  __breadcrumb__,
}) {
  const { trackResultClick } = useClickLogger(_click, url);
  return (
    <MediaList onClick={trackResultClick}>
      <MediaContent>
        <Link href={url}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
          <IconArrowRight />
        </Link>
        <div className="u-mt-25">
          {__eventsList__.map(event => (
            <TableRow>
              <TableCell className="description u-text-color-secondary u-text-lowercase u-text-first-uppercase">
                {event.when}
              </TableCell>
              <TableCell className="description u-text-color-secondary u-text-lowercase u-text-first-uppercase">
                {event.hours}
              </TableCell>
              <TableCell className="description u-text-color-secondary u-text-lowercase u-text-first-uppercase">
                {event.type}
              </TableCell>
            </TableRow>
          ))}
        </div>
        <Breadcrumb links={__breadcrumb__} modifierClasses="u-mt-50" disabled />
      </MediaContent>
    </MediaList>
  )
}
